import * as z from 'zod';
import { UserRole } from '@/constants/user';

export const userSchema = z.object({
  firstName: z.string().min(1, 'First name is required').max(50, 'First name is too long'),
  lastName: z.string().min(1, 'Last name is required').max(50, 'Last name is too long'),
  email: z.string().min(1, 'Email is required').email('Invalid email address').max(100, 'Email is too long'),
  userRole: z.nativeEnum(UserRole, { errorMap: () => ({ message: 'User role is required' }) })
});